import { Outlet } from "react-router-dom";

const PublicRoutesCheck = () => {
  return (
    <>
      {" "}
      <Outlet />
    </>
  );
};

export default PublicRoutesCheck;
